import * as lib from 'src/localization/lib';

export const localized = lib.localize({
  services: 'components.AppFooter.services',
  tos: 'components.AppFooter.tos',
  privacy: 'components.AppFooter.privacy'
});
